import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LogoComponent } from './logo.component';

/**
 * INFO: add comment
 */
@NgModule({
    declarations: [LogoComponent],
    exports: [LogoComponent],
    imports: [CommonModule],
})
export class UiLogoModule {}
